import React from 'react';

import PropTypes from 'prop-types';
import { Box, Divider, Notification, StackView, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import Table from './components/table';
import SectionHeading from '../sectionHeading';

const InstallServicesGeotab = ({
  installServicesList,
  contentfulError,
  viewType,
  installServices,
  setInstallServices,
  total,
  setTotal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { installationServicesHeading }
  } = localizedStrings;

  return (
    <>
      {contentfulError && (
        <Notification variant={{ validation: 'error' }}>
          Error fetching addons data from contentful
        </Notification>
      )}

      {!contentfulError && installServicesList.length > 0 && (
        <>
          <StackView space={3}>
            <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>{installationServicesHeading}</Typography></SectionHeading>
            <Table
              viewType={viewType}
              service={installServices}
              setService={setInstallServices}
              list={installServicesList}
              total={total}
              setTotal={setTotal}
            />
          </StackView>
          <Divider space={3} variant={{ inverse: true }} />
        </>
      )}
    </>
  );
};

InstallServicesGeotab.propTypes = {
  installServicesList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  contentfulError: PropTypes.shape({}).isRequired,
  viewType: PropTypes.string.isRequired,
  installServices: PropTypes.shape({}).isRequired,
  setInstallServices: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default InstallServicesGeotab;
